import React, { useState, useEffect } from 'react';
import { get } from 'lodash';
import { withFlux } from '@homie/flux';
import swal from 'sweetalert2';
import OwnerReportActions from 'modules/external_tenant/api/actions/OwnerReportActions';
import OwnerReportStore from 'modules/external_tenant/api/stores/OwnerReportStore';
import SignUpForm from './SignUpForm';
import ReportScore from './ReportScore';
import {
  StyledHeader,
  Paragraph,
  TenantName,
  WatchFullReportBtn,
  ReportContainerInner,
  ReportContainer
} from './styles';

type PartialReportProps = {
  applicationId: string,
  report: any,
  hiddenContent?: any,
  isAuthenticated: any,
  showLoadingProcess: (msg: string) => null,
  hideLoadingProcess: () => null
};

const PartialReport = ({
  applicationId,
  report,
  showLoadingProcess,
  hideLoadingProcess,
  hiddenContent,
  isAuthenticated
}: PartialReportProps) => {
  const [isSignUpFormOpen, setSignUpFormOpen] = useState(false);
  useEffect(() => {
    showLoadingProcess('Cargando reporte...');
    !isAuthenticated
      ? OwnerReportActions.fetchReportPreview(applicationId)
          .then(() => {
            hideLoadingProcess();
          })
          .catch(e => {
            hideLoadingProcess();
            swal({
              title: '¡Ha ocurrido un error!',
              text:
                (e.responseJson && e.responseJSON.message) ||
                'Ocurrió un error desconocido mientras se cargaban los datos del reporte',
              type: 'error'
            });
          })
      : hideLoadingProcess();
  }, []);

  const openSignUpForm = () => setSignUpFormOpen(true);

  const renderSmallReportContent = () => {
    if (
      !hiddenContent ||
      (hiddenContent && !isSignUpFormOpen && !isAuthenticated)
    ) {
      return (
        <ReportContainerInner>
          <div>
            <StyledHeader marginBottom={8} type="primary">
              Renta tu departamento con Homie
            </StyledHeader>
            <TenantName>{get(report, 'user_short_name', '')}</TenantName>
            <Paragraph>
              Fue aprobado por Homie como buen inquilino para vivir en tu
              inmueble.
            </Paragraph>
          </div>
          <ReportScore score={get(report, 'homie_score', 0)} />
        </ReportContainerInner>
      );
    }
    return null;
  };

  const renderContentToggler = () => {
    if (!isSignUpFormOpen && !isAuthenticated) {
      return (
        <WatchFullReportBtn onClick={openSignUpForm}>
          Ver reporte completo <img src="/assets/chevron-down.png" height={8} />
        </WatchFullReportBtn>
      );
    }
  };

  const renderHiddenContent = () => {
    if (isSignUpFormOpen || isAuthenticated) {
      return hiddenContent ? (
        hiddenContent
      ) : (
        <ReportContainer>
          <SignUpForm
            visible={true}
            showLoadingProcess={showLoadingProcess}
            hideLoadingProcess={hideLoadingProcess}
          />
        </ReportContainer>
      );
    }
    return null;
  };

  return (
    <div>
      <ReportContainer>
        {renderSmallReportContent()}
        {renderContentToggler()}
      </ReportContainer>
      {renderHiddenContent()}
    </div>
  );
};

export default withFlux([OwnerReportStore], () => ({
  report: OwnerReportStore.getReportPreview()
}))(PartialReport);
